<template>
    <div id="Country" class="page" data-page="country">

        <div id="CiteModalWrapper" :class="(citationModalDisplayed) ? 'displayed' : ''">
            <div id="CiteModalBg" @click="closeCitationModal()"></div>
            <div id="CiteModal">
                <div class="modal_closebt" @click="closeCitationModal()"></div>
                <div class="modal_title">How to cite ?</div>
                <div class="modal_text" v-html="citationModalText"></div>
                <div class="modal_buttons">
                    <div class="modal_bt" @click="updateModalText('text')" :class="(copiedType == 'text') ? 'copied' : ''">
                        <span class="copied_text">Copied</span>
                        <span class="bt_text">Copy text</span>
                    </div>
                    <div class="modal_bt" @click="updateModalText('apa')" :class="(copiedType == 'apa') ? 'copied' : ''">
                        <span class="copied_text">Copied</span>
                        <span class="bt_text">Copy APA</span>
                    </div>
                    <div class="modal_bt" @click="updateModalText('bip')" :class="(copiedType == 'bip') ? 'copied' : ''">
                        <span class="copied_text">Copied</span>
                        <span class="bt_text">Copy BipTex</span>
                    </div>
                </div>
            </div>
        </div>

        <appModal ref="appModalRef" :countries="DBCountries"></appModal>
        <appHeader bgColor="blue" @headerMenuClicked="menuClicked" page="country"  :stickyTitle="countryObj.country_name"></appHeader>
        <div class="main">
            <div class="main_loader loader lds-ellipsis" :class="(mainLoaderDisplayed) ? 'displayed' : ''"><div></div><div></div><div></div><div></div></div>
            <div class="main_inner" :class="(mainLoaderDisplayed) ? 'opacified' : ''">
                <section class="main_section">
                    <div class="section_content" id="CountryInfos">
                        <h2 class="text_subtitle">Countries</h2>
                        <h1 class="title_page text_title2">
                            {{countryObj.country_name}}
                        </h1>
                        <button class="app_button2" @click="openModal('country')" style="margin-top: 20px;">Change country</button>
                        <p class="text_p" style="margin-top: 14px;">
                            Scroll down to view country-specific data for each of the four topics covered by the Atlas.
                        </p>
                    </div>
                </section>

                <section id="Wrapper_profit" class="main_section section_chart" data-dataset="global-profit">
                    <div class="section_content">
                        <div class="title_taxhaven" v-if="isTaxHavenGlobalProfit">{{countryObj.country_name}} is classified as a tax haven</div>
                        <div class="content_title" v-if="DBDatasetsTexts['global-profit'] != undefined">
                            {{ DBDatasetsTexts['global-profit'].title }}
                        </div>
                        <div class="section_hr" v-if="globalProfitHasData">
                            <div class="hr_text dataset">Indicator Filters</div>
                        </div>
                        <div class="section_row row_filters" data-align="left" v-if="globalProfitHasData">
                            <div class="content_filter">
                                <div class="filter_label">Indicator</div>

                                <v-select class="actionblock_selectbox app_selectbox" v-model="selectedGlobalProfitIndicator" :items="globalProfitIndicators" :return-object="true" label="Choose an indicator" solo>
                                    <template slot="selection" scope="data">
                                        <div class="item_wrapper">
                                            <div class="item_text">{{ truncateSelectboxItem(data.item.label) }}</div>
                                        </div>
                                    </template>
                                    <template slot="item" slot-scope="data">
                                        <div class="item_wrapper" :data-item="data.item.id">
                                            <div class="item_text"><span class="item_icon"></span>{{data.item.label}}</div>
                                        </div>
                                    </template>
                                </v-select>

                                <!--
                                <select class="filter_selectbox">
                                    <option v-for="(indicatorLabel, indicatorKey) in globalProfitIndicatorsKeys">
                                        {{indicatorLabel}}
                                    </option>
                                </select>
                                -->
                            </div>
                        </div>
                        <div v-if="globalProfitHasData" class="section_row">
                            <div class="country_wrapper">

                                <div class="area_title" v-if="isDataLoaded && selectedGlobalProfitIndicator.id != 'corp_tax_lost'">
                                    <span class="title_label">{{ selectedGlobalProfitIndicator.label }}</span>
                                    <div class="title_lostwon" :data-taxhavens="(isTaxHavenGlobalProfit) ? 'true': ''">
                                        <span v-if="!isTaxHavenGlobalProfit">lost</span>
                                        <span v-else>won</span>
                                    </div>
                                    <span class="title_label unit">&nbsp;(in {{globalProfitIndicatorUnit}})</span>
                                </div>

                                <div class="area_title" v-else-if="isDataLoaded && selectedGlobalProfitIndicator.id == 'corp_tax_lost'">
                                    <span class="title_label">Corporate tax revenue</span>
                                    <div class="title_lostwon" :data-taxhavens="(isTaxHavenGlobalProfit) ? 'true': ''">
                                        <span v-if="!isTaxHavenGlobalProfit">lost</span>
                                        <span v-else>won</span>
                                    </div>
                                    <span class="title_label">as a share of corporate tax revenue collected</span>
                                    <span class="title_label unit">&nbsp;(in {{globalProfitIndicatorUnit}})</span>
                                </div>


                                <highchartsAreaChart :areaChartData="globalProfitAreaSeries" :areaChartCategories="globalProfitAreaCategories" :indicatorUnit="globalProfitIndicatorUnit"></highchartsAreaChart>
                            </div>

                            <div class="content_downloadbar">
                                <div class="downloadbar_wrapper">
                                    <div class="downloadbar_title">Download</div>
                                    <div class="downloadbar_bt" @click="exportXLS('profit')">Dataset (.xslx)</div>
                                    <div class="downloadbar_bt" @click="exportGraphic('profit')">Image (.png)</div>
                                    <div class="downloadbar_bt cite" @click="displayCitationModal('global-profit')">Cite</div>
                                </div>
                            </div>
                            <div class="content_more" v-if="DBDatasetsTexts['global-profit'] != undefined">
                                <div class="more_text">
                                    <div v-if="globalProfitTextExpanded">
                                        <span v-if="isTaxHavenGlobalProfit">{{ DBDatasetsTexts['global-profit'].Country_Page_Desc_Tax }}</span>
                                        <span v-else>{{ DBDatasetsTexts['global-profit'].Country_Page_Desc_NonTax }} </span>
                                    </div>
                                    <div v-else>
                                        <span v-if="isTaxHavenGlobalProfit">{{ truncate(DBDatasetsTexts['global-profit'].Country_Page_Desc_Tax) }}</span>
                                        <span v-else>{{ truncate(DBDatasetsTexts['global-profit'].Country_Page_Desc_NonTax) }} </span>
                                    </div>
                                </div>
                                <div class="more_actionbar" v-if="(isTaxHavenGlobalProfit && DBDatasetsTexts['global-profit'].Country_Page_Desc_Tax.length > datasetTextLimit) || (!isTaxHavenGlobalProfit && DBDatasetsTexts['global-profit'].Country_Page_Desc_NonTax.length > datasetTextLimit)">
                                    <div class="actionbar_bt" @click="globalProfitTextExpanded = !globalProfitTextExpanded">{{ globalProfitTextExpanded ? 'Collapse' : 'Read More' }}</div>
                                </div>
                            </div>

                        </div>
                        <div v-else class="section_row">
                            <div class="chart_nodatablock">
                            </div>
                        </div>
                    </div>
                </section>


                <section class="main_section section_chart" data-dataset="offshore-financial">
                    <div class="section_content">
                        <div class="title_taxhaven" v-if="isTaxHavenOffshoreFinancial">{{countryObj.country_name}} is classified as a financial center</div>
                        <div class="content_title" v-if="isDataLoaded">
                            <span v-if="isTaxHavenOffshoreFinancial">
                                Offshore financial wealth hosted by {{countryObj.country_name}}
                            </span>
                            <span v-else>
                                Offshore financial wealth owned by {{countryObj.country_name}}
                            </span>
                        </div>
                        <div class="section_hr" v-if="offshoreFinancialHasData">
                            <div class="hr_text">Indicator Filters</div>
                        </div>
                        <div class="section_row row_filters" data-align="left" v-if="offshoreFinancialHasData">
                            <div class="content_filter">
                                <div class="filter_label">Indicator</div>

                                <v-select class="actionblock_selectbox app_selectbox" v-model="selectedOffshoreFinancialIndicator" :items="offshoreFinancialIndicators" :return-object="true" label="Choose an indicator" solo>
                                    <template slot="selection" scope="data">
                                        <div class="item_wrapper">
                                            <div class="item_text">{{ truncateSelectboxItem(data.item.label) }}</div>
                                        </div>
                                    </template>
                                    <template slot="item" slot-scope="data">
                                        <div class="item_wrapper" :data-item="data.item.id">
                                            <div class="item_text"><span class="item_icon"></span>{{data.item.label}}</div>
                                        </div>
                                    </template>
                                </v-select>
                            </div>
                        </div>
                        <div class="section_row" v-if="offshoreFinancialHasData">
                            <div id="Wrapper_financial" class="country_wrapper">
                                <div class="legend_title" v-if="isDataLoaded">
                                    <div class="title_indicator">{{selectedOffshoreFinancialIndicator.subtitleLabel}}</div>
                                    <div class="title_taxhavens" :data-taxhavens="(isTaxHavenOffshoreFinancial) ? 'true': ''">
                                        <span v-if="!isTaxHavenOffshoreFinancial">owned</span>
                                        <span v-else>held</span>
                                    </div>
                                    <div class="title_unit" v-if="selectedOffshoreFinancialIndicator.homeUnit != undefined">(in {{selectedOffshoreFinancialIndicator.homeUnit}})</div>
                                    <div class="title_unit" v-else>(in {{selectedOffshoreFinancialIndicator.unit}})</div>
                                </div>
                                <highchartsAreaChart :areaChartData="offshoreFinancialAreaSeries" :areaChartCategories="offshoreFinancialAreaCategories" :indicatorUnit="offshoreFinancialAreaUnit" chartID="AreaChartOffshore"></highchartsAreaChart>
                            </div>
                            <div class="content_downloadbar">
                                <div class="downloadbar_wrapper">
                                    <div class="downloadbar_title">Download</div>
                                    <div class="downloadbar_bt" @click="exportXLS('financial')">Dataset (.xslx)</div>
                                    <div class="downloadbar_bt" @click="exportGraphic('financial')">Image (.png)</div>
                                    <div class="downloadbar_bt cite" @click="displayCitationModal('offshore-financial')">Cite</div>
                                </div>
                            </div>
                            <div class="content_more" v-if="DBDatasetsTexts['offshore-financial'] != undefined">
                                <div class="more_text">
                                    <div v-if="offshoreFinancialTextExpanded">
                                        <span v-if="isTaxHavenOffshoreFinancial">{{ DBDatasetsTexts['offshore-financial'].Country_Page_Desc_Tax }}</span>
                                        <span v-else>{{ DBDatasetsTexts['offshore-financial'].Country_Page_Desc_NonTax }} </span>
                                    </div>
                                    <div v-else>
                                        <span v-if="isTaxHavenOffshoreFinancial">{{ truncate(DBDatasetsTexts['offshore-financial'].Country_Page_Desc_Tax) }}</span>
                                        <span v-else>{{ truncate(DBDatasetsTexts['offshore-financial'].Country_Page_Desc_NonTax) }} </span>
                                    </div>
                                </div>
                                <div class="more_actionbar" v-if="(isTaxHavenOffshoreFinancial && DBDatasetsTexts['offshore-financial'].Country_Page_Desc_Tax.length > datasetTextLimit || !isTaxHavenOffshoreFinancial && DBDatasetsTexts['offshore-financial'].Country_Page_Desc_NonTax.length > datasetTextLimit) ">
                                    <div class="actionbar_bt" @click="offshoreFinancialTextExpanded = !offshoreFinancialTextExpanded">{{ offshoreFinancialTextExpanded ? 'Collapse' : 'Read More' }}</div>
                                </div>
                            </div>
                        </div>
                        <div class="section_row" v-else>
                            <div class="chart_nodatablock">
                            </div>
                        </div>
                    </div>
                </section>

                <section class="main_section section_chart" data-dataset="offshore-financial" v-if="isHybridOffshoreFinancial">
                    <div class="section_content">
                        <div class="title_taxhaven">{{countryObj.country_name}} is classified as a financial center</div>
                        <div class="content_title" v-if="isDataLoaded">
                            <span>
                                Offshore financial wealth hosted by {{countryObj.country_name}}
                            </span>
                        </div>
                        <div class="section_hr" v-if="offshoreFinancialHybridHasData">
                            <div class="hr_text">Indicator Filters</div>
                        </div>
                        <div class="section_row row_filters" data-align="left" v-if="offshoreFinancialHybridHasData">
                            <div class="content_filter">
                                <div class="filter_label">Indicator</div>

                                <v-select class="actionblock_selectbox app_selectbox" v-model="selectedOffshoreFinancialHybridIndicator" :items="offshoreFinancialHybridIndicators" :return-object="true" label="Choose an indicator" solo>
                                    <template slot="selection" scope="data">
                                        <div class="item_wrapper">
                                            <div class="item_text">{{ truncateSelectboxItem(data.item.label) }}</div>
                                        </div>
                                    </template>
                                    <template slot="item" slot-scope="data">
                                        <div class="item_wrapper" :data-item="data.item.id">
                                            <div class="item_text"><span class="item_icon"></span>{{data.item.label}}</div>
                                        </div>
                                    </template>
                                </v-select>
                            </div>
                        </div>
                        <div class="section_row" v-if="offshoreFinancialHybridHasData">
                            <div id="Wrapper_financial-hybrid" class="country_wrapper">
                                <div class="legend_title" v-if="isDataLoaded">
                                    <div class="title_indicator">{{selectedOffshoreFinancialHybridIndicator.subtitleLabel}}</div>
                                    <div class="title_taxhavens" data-taxhavens="true">
                                        <span>held</span>
                                    </div>
                                    <div class="title_unit" v-if="selectedOffshoreFinancialHybridIndicator.homeUnit != undefined">(in {{selectedOffshoreFinancialHybridIndicator.homeUnit}})</div>
                                    <div class="title_unit" v-else>(in {{selectedOffshoreFinancialHybridIndicator.unit}})</div>
                                </div>
                                <highchartsAreaChart :areaChartData="offshoreFinancialHybridAreaSeries" :areaChartCategories="offshoreFinancialHybridAreaCategories" :indicatorUnit="offshoreFinancialHybridAreaUnit" chartID="AreaChartOffshoreHybrid"></highchartsAreaChart>
                            </div>
                            <div class="content_downloadbar">
                                <div class="downloadbar_wrapper">
                                    <div class="downloadbar_title">Download</div>
                                    <div class="downloadbar_bt" @click="exportXLS('financial-hybrid')">Dataset (.xslx)</div>
                                    <div class="downloadbar_bt" @click="exportGraphic('financial-hybrid')">Image (.png)</div>
                                    <div class="downloadbar_bt cite" @click="displayCitationModal('offshore-financial')">Cite</div>
                                </div>
                            </div>
                            <div class="content_more" v-if="DBDatasetsTexts['offshore-financial'] != undefined">
                                <div class="more_text">
                                    <div v-if="offshoreFinancialTextExpanded">
                                        <span>{{ DBDatasetsTexts['offshore-financial'].Country_Page_Desc_Tax }}</span>
                                    </div>
                                    <div v-else>
                                        <span>{{ truncate(DBDatasetsTexts['offshore-financial'].Country_Page_Desc_Tax) }}</span>
                                    </div>
                                </div>
                                <div class="more_actionbar" v-if="DBDatasetsTexts['offshore-financial'].Country_Page_Desc_Tax.length > datasetTextLimit">
                                    <div class="actionbar_bt" @click="offshoreFinancialHybridTextExpanded = !offshoreFinancialHybridTextExpanded">{{ offshoreFinancialHybridTextExpanded ? 'Collapse' : 'Read More' }}</div>
                                </div>
                            </div>
                        </div>
                        <div class="section_row" v-else>
                            <div class="chart_nodatablock">
                            </div>
                        </div>
                    </div>
                </section>


                <section class="main_section section_chart" data-dataset="offshore-real-estate">
                    <div class="section_content">
                        <div class="content_title" v-if="DBDatasetsTexts['offshore-real-estate'] != undefined">
                            Offshore real estate wealth in 6 global cities and regions
                        </div>
                        <div class="section_row" v-if="offshoreEstateHasData">
                            <div class="row_estate_item">
                                <div class="estate_item_wrapper">
                                    <div class="estate_item_label">
                                        Total offshore<br />real estate wealth 
                                    </div>
                                    <div class="estate_item_value" v-if="offshoreEstateTotal != ''">
                                        {{offshoreEstateTotal.toFixed(2)}} bn USD
                                    </div>
                                </div>
                            </div>

                            <div class="row_estate_item">
                                <div class="estate_item_wrapper">
                                    <div class="estate_item_label">
                                        Percentage of country's GDP
                                    </div>
                                    <div class="estate_item_value">
                                        {{offshoreEstatePctGDP}}%
                                    </div>
                                </div>
                            </div>
                            <!--
                            <div class="row_estate_item">
                                <div class="estate_item_wrapper">
                                    <div class="estate_item_label">
                                        Percentage of total real estate in the world
                                    </div>
                                    <div class="estate_item_value">
                                        {{offshoreEstatePctWorld}}%
                                    </div>
                                </div>
                            </div>
                            -->
                        </div>
                        <div class="section_hr" v-if="offshoreEstateHasData">
                            <div class="hr_text">Indicator Filters</div>
                        </div>
                        <div class="section_row row_filters" data-align="left" v-if="offshoreEstateHasData">
                            <div class="content_filter">
                                <div class="filter_label">Indicator</div>

                                <v-select class="actionblock_selectbox app_selectbox" v-model="selectedOffshoreEstateIndicator" :items="offshoreEstateIndicators" :return-object="true" label="Choose an indicator" solo>
                                    <template slot="selection" scope="data">
                                        <div class="item_wrapper">
                                            <div class="item_text">{{ truncateSelectboxItem(data.item.label) }}</div>
                                        </div>
                                    </template>
                                    <template slot="item" slot-scope="data">
                                        <div class="item_wrapper" :data-item="data.item.id">
                                            <div class="item_text"><span class="item_icon"></span>{{data.item.label}}</div>
                                        </div>
                                    </template>
                                </v-select>
                            </div>
                        </div>
                        <div class="section_row" v-if="offshoreEstateHasData">
                            <div class="legend_title" v-if="isDataLoaded">
                                <div class="title_indicator" v-if="selectedOffshoreEstateIndicator.id == 'pctGDP'">Offshore real estate owned as a share of country’s GDP</div>
                                <div class="title_indicator" v-else-if="selectedOffshoreEstateIndicator.id == 'Aggregate (in USD billions)'">Total offshore real estate owned</div>
                                <div class="title_indicator" style="display: inline" v-else-if="selectedOffshoreEstateIndicator.id == 'pctGlobalEstate'">Share of total offshore real estate in city: Offshore real estate owned as a share of the total offshore real estate in the city or area</div>
                                <div class="title_unit">&nbsp;(in {{offshoreEstateIndicatorUnit}})</div>
                            </div>
                            <div class="row_estate_barchart country_wrapper" id="Wrapper_estate">
                                <highchartsBarChart :barChartData="offshoreEstateSeries" :barChartCategories="offshoreEstateCategories" :indicatorUnit="offshoreEstateIndicatorUnit"></highchartsBarChart>
                            </div>
                            <div class="content_downloadbar">
                                <div class="downloadbar_wrapper">
                                    <div class="downloadbar_title">Download</div>
                                    <div class="downloadbar_bt" @click="exportXLS('estate')">Dataset (.xslx)</div>
                                    <div class="downloadbar_bt" @click="exportGraphic('estate')">Image (.png)</div>
                                    <div class="downloadbar_bt cite" @click="displayCitationModal('offshore-real-estate')">Cite</div>
                                </div>
                            </div>
                            <div class="content_more" v-if="DBDatasetsTexts['offshore-real-estate'] != undefined">
                                <div class="more_text">
                                    <div v-if="offshoreEstateTextExpanded">
                                        {{ DBDatasetsTexts['offshore-real-estate'].Country_Page_Desc_NonTax }}
                                    </div>
                                    <div v-else>{{ truncate(DBDatasetsTexts['offshore-real-estate'].Country_Page_Desc_NonTax) }}</div>
                                </div>
                                <div class="more_actionbar" v-if="DBDatasetsTexts['offshore-real-estate'].Country_Page_Desc_NonTax.length > datasetTextLimit">
                                    <div class="actionbar_bt" @click="offshoreEstateTextExpanded = !offshoreEstateTextExpanded">{{ offshoreEstateTextExpanded ? 'Collapse' : 'Read More' }}</div>
                                </div>
                            </div>
                        </div>
                        <div class="section_row" v-else>
                            <div class="chart_nodatablock"></div>
                        </div>
                    </div>
                </section>

                <section class="main_section section_chart" data-dataset="effective-tax">
                    <div class="section_content">
                        <div class="content_title" v-if="DBDatasetsTexts['effective-tax'] != undefined">
                            {{DBDatasetsTexts['effective-tax'].title}}
                        </div>

                        <div class="section_row" v-if="effectiveTaxHasData">
                            <div id="Wrapper_effective" class="country_wrapper">
                                <highchartsTimeSeries :timeSeriesData="effectiveTaxSeries" :timeSeriesCategories="effectiveTaxCategories" indicatorUnit="%"></highchartsTimeSeries>
                            </div>

                            <div class="content_downloadbar">
                                <div class="downloadbar_wrapper">
                                    <div class="downloadbar_title">Download</div>
                                    <div class="downloadbar_bt" @click="exportXLS('effective')">Dataset (.xslx)</div>
                                    <div class="downloadbar_bt" @click="exportGraphic('effective')">Image (.png)</div>
                                    <div class="downloadbar_bt cite" @click="displayCitationModal('effective-tax')">Cite</div>
                                </div>
                            </div>
                            <div class="content_more" v-if="DBDatasetsTexts['effective-tax'] != undefined">
                                <div class="more_text">
                                    <div v-if="effectiveTaxTextExpanded">
                                        {{ DBDatasetsTexts['effective-tax'].Country_Page_Desc_NonTax }}
                                    </div>
                                    <div v-else>{{ truncate(DBDatasetsTexts['effective-tax'].Country_Page_Desc_NonTax) }}</div>
                                </div>
                                <div class="more_actionbar" v-if="DBDatasetsTexts['effective-tax'].Country_Page_Desc_NonTax.length > datasetTextLimit">
                                    <div class="actionbar_bt" @click="effectiveTaxTextExpanded = !effectiveTaxTextExpanded">{{ effectiveTaxTextExpanded ? 'Collapse' : 'Read More' }}</div>
                                </div>
                            </div>
                        </div>

                        <div v-else class="section_row">
                            <div class="chart_nodatablock">
                            </div>
                        </div>
                    </div>
                </section>

                
            </div> 
        </div>
        <appFooter></appFooter>
        <cookiesConsent></cookiesConsent>
    </div>
</template>

<script>
    import * as d3 from 'd3'
    import { mapState, mapGetters, mapActions } from 'vuex'
    import Vue from 'vue'
    import * as UTILS from '~/commons/utils/index.js'
    import {_} from 'underscore'
    var slugify = require("underscore.string/slugify")
    var numberFormat = require('underscore.string/numberFormat')

    import Vuetify from 'vuetify'
    Vue.use(Vuetify)
    import 'vuetify/dist/vuetify.min.css'

    import appHeader from '~/components/appHeader.vue'
    import appFooter from '~/components/appFooter.vue'
    import appModal from '~/components/appModal.vue'
    import highchartsAreaChart from '~/components/highchartsAreaChart.vue'
    import highchartsTimeSeries from '~/components/highchartsTimeSeries.vue'
    import highchartsBarChart from '~/components/highchartsBarChart.vue'
    import cookiesConsent from '~/components/cookiesConsent.vue'

    export default {
        components: {
            "appHeader": appHeader,
            "appFooter": appFooter,
            "appModal": appModal,
            "highchartsAreaChart": highchartsAreaChart,
            "highchartsTimeSeries": highchartsTimeSeries,
            "highchartsBarChart": highchartsBarChart,
            "cookiesConsent": cookiesConsent
        },

        data: function () {
            return {
                isDataLoaded: false,
                countryID: "",
                countryObj: { country_name: "" },
                DBDatasets: {
                    "effective-tax": {},
                    "global-profit": {},
                    "offshore-financial": {},
                    "offshore-real-estate": {},
                },
                DBCountries:[],
                DBCountriesDenominator: [],
                DBRealEstateCities: {},
                datasetsParams: {},
                datasetTextLimit: 330,

                globalProfitCountryData: {},
                globalProfitIndicators: [],
                selectedGlobalProfitIndicator: {},
                globalProfitAreaSeries: [],
                globalProfitAreaCategories: [],
                globalProfitIndicatorUnit: "",
                globalProfitHasData: true,
                isTaxHavenGlobalProfit: false,
                globalProfitTextExpanded: false,

                effectiveTaxCountryData: {},
                effectiveTaxSeries: [],
                effectiveTaxCategories: [],
                effectiveTaxTextExpanded: false,
                effectiveTaxHasData: true,

                offshoreFinancialCountryData: {},
                offshoreFinancialAreaSeries: [],
                offshoreFinancialAreaCategories: [],
                offshoreFinancialIndicators: [],
                selectedOffshoreFinancialIndicator: {},
                offshoreFinancialAreaUnit: "",
                isTaxHavenOffshoreFinancial: false,
                isHybridOffshoreFinancial: false,
                offshoreFinancialHasData: true,
                offshoreFinancialTextExpanded: false,

                offshoreFinancialHybridCountryData: {},
                offshoreFinancialHybridIndicators: [],
                selectedOffshoreFinancialHybridIndicator: {},
                offshoreFinancialHybridAreaSeries: [],
                offshoreFinancialHybridAreaCategories: [],
                offshoreFinancialHybridAreaUnit: "",
                offshoreFinancialHybridTextExpanded: false,
                offshoreFinancialHybridHasData: false,

                offshoreEstateCountryData: {},
                offshoreEstateTotal: "",
                offshoreEstatePctGDP: "",
                offshoreEstatePctWorld: "",
                offshoreEstateSeries: [],
                offshoreEstateCategories: [],
                offshoreEstateIndicators: [],
                selectedOffshoreEstateIndicator: {},
                offshoreEstateIndicatorUnit: "",
                offshoreEstateTextExpanded: false,
                offshoreEstateHasData: true,

                selectboxItemLimit: 35,
                mainLoaderDisplayed: true,
                DBDatasetsTexts: {},

                loadingMethod: "csv",

                citationObj: {},
                citationModalText: "",
                citationModalDisplayed: false,
                citationModalDatasetID: "",
                citationType: "text",
                copiedType: ""
            }
        },

        created: function () {

        },

        mounted: function () {
            var self = this; 

            //if(location.host == "staging-eu-tax-observatory.wedodata.dev") this.loadingMethod = "gsheet";

            this.countryID = this.$route.params.countryID;
            this.datasetsParams = UTILS.DATASETS_PARAMS;
            //this.loadCSVData();
            this.handleScroll();

            document.querySelector("body").setAttribute("data-fixed", "true");

            if(this.loadingMethod == "csv"){
                this.loadTextsCSVData();
            } else {
                this.loadTextsSpreadsheetData();
            }
        },

        methods: {

            handleScroll: function (){
                var self = this;
                window.onscroll = function() {
                    var app = document.getElementById('app');
                    var specificElement = document.getElementById('CountryInfos');

                    if(specificElement != undefined){
                        var triggerPoint = specificElement.offsetTop + specificElement.offsetHeight - 60;

                        if (window.pageYOffset > triggerPoint) {
                            app.classList.add("sticky");
                        } else {
                            app.classList.remove("sticky");
                        }
                    }
                    
                };
            },

            loadTextsCSVData: function (){
                var self = this;

                UTILS.loadTextsCSVData().then(function (callbackDBTexts){
                    self.DBDatasetsTexts = {};
                    _.each(callbackDBTexts, function (o){
                        self.DBDatasetsTexts[o.dataset_id] = o;
                    })
                    self.loadCountriesCSVMetadata();
                }).catch(err => {
                    console.log(err);
                  });
            },

            loadTextsSpreadsheetData: function () {
                var self = this;

                UTILS.loadTextsSpreadsheetData().then(function (callbackDBTexts){
                    self.DBDatasetsTexts = {};
                    _.each(callbackDBTexts, function (o){
                        self.DBDatasetsTexts[o.dataset_id] = o;
                    })
                    self.loadCountriesMetadata();
                }).catch(err => {
                    console.log(err);
                  });
            },

            loadCountriesMetadata: function (){
                var self = this;

                this.mainLoaderDisplayed = false;
                document.querySelector("body").setAttribute("data-fixed", "false");

                UTILS.loadCountriesSpreadsheetData(true).then(function (callbackDBCountries){
                    self.DBCountries = JSON.parse(JSON.stringify(callbackDBCountries.dbCountries));
                    self.DBCountriesDenominator = JSON.parse(JSON.stringify(callbackDBCountries.dbCountriesDenominator));
                    self.countryObj = _.find(self.DBCountries, function (o){
                        return o.iso3 == self.countryID;
                    });
                    self.loadSpreadsheetData()
                }).catch(err => {
                    console.log(err);
                  });
            },

            loadCountriesCSVMetadata: function (){
                var self = this;

                this.mainLoaderDisplayed = false;
                document.querySelector("body").setAttribute("data-fixed", "false");

                UTILS.loadCountriesCSVData(true).then(function (callbackDBCountries){
                    self.DBCountries = JSON.parse(JSON.stringify(callbackDBCountries.dbCountries));
                    self.DBCountriesDenominator = JSON.parse(JSON.stringify(callbackDBCountries.dbCountriesDenominator));
                    self.countryObj = _.find(self.DBCountries, function (o){
                        return o.iso3 == self.countryID;
                    });
                    self.loadCSVData()
                }).catch(err => {
                console.log(err);
              });
            },

            loadSpreadsheetData: function (){
                var self = this;
                UTILS.loadDatasetsSpreadsheetData().then(function (callbackDBDatasets){
                    self.DBDatasets = JSON.parse(JSON.stringify(callbackDBDatasets));
                    self.populateData();
                });
            },

            loadCSVData: function (){
                var self = this;

                UTILS.loadDatasetsCSVData().then(function (callbackDBDatasets){
                    self.DBDatasets = JSON.parse(JSON.stringify(callbackDBDatasets));
                    self.populateData();
                });
            },

            displayCitationModal: function (datasetID){
                this.citationObj = UTILS.CITATIONS_OBJ[datasetID];
                this.citationModalText = this.citationObj[this.citationType];
                this.citationModalDisplayed = true;
                this.citationModalDatasetID = datasetID;
            },

            closeCitationModal: function (){
                this.citationModalDisplayed = false;
                this.citationType = "text";
                this.copiedType = "";
            },

            updateModalText: function (citationType){
                var self = this;

                this.citationType = citationType;
                this.citationModalText = this.citationObj[this.citationType];
                // Use the Clipboard API to copy the text
                navigator.clipboard.writeText(this.citationModalText).then(function() {
                    setTimeout(function (){
                        self.copiedType = citationType;
                    }, 300)

                    setTimeout(function (){
                        self.copiedType = "";
                    }, 2000)
                    
                }).catch(function(err) {
                    console.error('Could not copy text: ', err);
                });
            },

            populateData: function (){
                var self = this;
                this.isDataLoaded = true;
                this.DBRealEstateCities = UTILS.DB_REALESTATE_CITIES;

                //Global Profit
                this.globalProfitCountryData = this.DBDatasets["global-profit"][this.countryID];
                if(this.globalProfitCountryData != undefined){
                    if(this.countryObj.Tax_haven_profit_shifting == "yes"){
                        this.isTaxHavenGlobalProfit = true;
                    }
                    var indicatorsKeys = _.keys(this.globalProfitCountryData.indicators);
                    var tmpIndicators = _.map(indicatorsKeys, function (indicatorKey){
                        return UTILS.INDICATORS_PARAMS[indicatorKey];
                    });

                    this.globalProfitIndicators = JSON.parse(JSON.stringify(UTILS.DATASETS_PARAMS["global-profit"].indicators));
                    this.selectedGlobalProfitIndicator = this.globalProfitIndicators[0];
                    this.globalProfitHasData = true;
                    this.updateGlobalProfitChart();
                } else {
                    this.globalProfitHasData = false;
                }

                //Effective tax
                this.effectiveTaxCountryData = this.DBDatasets["effective-tax"][this.countryID];
                /*
                this.effectiveTaxIndicators = JSON.parse(JSON.stringify(UTILS.DATASETS_PARAMS["effective-tax"].indicators));
                this.selectedEffectiveTaxIndicator = this.effectiveTaxIndicators[0];
                */
                this.updateEffectiveTaxChart();

                //Offshore financial
                if(this.countryObj.Tax_haven_offshore_financial_wealth == "yes"){
                    this.isTaxHavenOffshoreFinancial = true;
                }

                if(this.countryObj.Tax_haven_offshore_financial_wealth == "both"){
                    this.isHybridOffshoreFinancial = true;
                }

                this.offshoreFinancialCountryData = this.DBDatasets["offshore-financial"][this.countryID];
                this.offshoreFinancialIndicators = JSON.parse(JSON.stringify(UTILS.DATASETS_PARAMS["offshore-financial"].indicators));
                this.selectedOffshoreFinancialIndicator = this.offshoreFinancialIndicators[0];
                this.updateOffshoreFinancialChart();

                if(this.isHybridOffshoreFinancial){
                    this.offshoreFinancialHybridCountryData = this.DBDatasets["offshore-financial"][this.countryID];
                    this.offshoreFinancialHybridIndicators = JSON.parse(JSON.stringify(UTILS.DATASETS_PARAMS["offshore-financial"].indicators));
                    this.selectedOffshoreFinancialHybridIndicator = this.offshoreFinancialHybridIndicators[0];
                    this.updateOffshoreFinancialHybridChart();
                }

                //Offshore estate
                this.offshoreEstateCountryData = this.DBDatasets["offshore-real-estate"][this.countryID];
                this.offshoreEstateIndicators = JSON.parse(JSON.stringify(UTILS.DATASETS_PARAMS["offshore-real-estate"].indicators));
                this.selectedOffshoreEstateIndicator = this.offshoreEstateIndicators[0];

                this.updateOffshoreEstateKeyFigures();
                this.updateOffshoreEstateChart();
                
            },

            updateGlobalProfitChart: function (){
                var self = this;
                var indicatorObj = {};
                if(this.isTaxHavenGlobalProfit) indicatorObj = this.globalProfitCountryData.indicators[this.selectedGlobalProfitIndicator.taxHavenID];
                else indicatorObj = this.globalProfitCountryData.indicators[this.selectedGlobalProfitIndicator.id];

                this.globalProfitIndicatorUnit = this.selectedGlobalProfitIndicator.smallUnit;
                var counterparts = indicatorObj.counterparts;

                var dataType = "none";
                if(this.countryObj.Tax_haven_profit_shifting == "yes"){
                    if(counterparts["World"] != undefined) dataType = "world";
                    else if(counterparts["EU_Havens"] !== undefined && counterparts["Non_EU_Havens"] !== undefined) dataType = "havens";
                } else {
                    if(counterparts["EU_Havens"] !== undefined && counterparts["Non_EU_Havens"] !== undefined) dataType = "havens";
                    else if(counterparts["World"] != undefined) dataType = "world";
                }

                var tmpSeries = [];
                var tmpCategories = [];

                if(dataType == "havens") {
                    tmpCategories = _.keys(counterparts["Non_EU_Havens"].years);
                    tmpSeries.push({
                        name: "Non EU Havens",
                        color: "#BAC6DF",
                        data: _.map(counterparts["Non_EU_Havens"].years, function (yObj){ return yObj.value; })
                    })
                    tmpSeries.push({
                        name: "EU Havens",
                        color: "#204FAA",
                        data: _.map(counterparts["EU_Havens"].years, function (yObj){ return yObj.value; })
                    })
                } else if(dataType == "world"){
                    tmpCategories = _.keys(counterparts["World"].years);
                    tmpSeries.push({
                        name: "World",
                        color: (self.isTaxHavenGlobalProfit) ? "#F18321" : "#204FAA",
                        data: _.map(counterparts["World"].years, function (yObj){ return yObj.value; })
                    })
                }

                this.globalProfitAreaSeries = JSON.parse(JSON.stringify(tmpSeries));
                this.globalProfitAreaCategories = JSON.parse(JSON.stringify(tmpCategories));
            },

            updateEffectiveTaxChart: function (){
                var tmpTaxSeries = [];
                var tmpCategories = [];
                var nbValues = 0;

                _.each(this.effectiveTaxCountryData.indicators, function (indicatorObj, indicatorID){
                    var indicatorParamsObj = _.find(UTILS.DATASETS_PARAMS["effective-tax"].indicators, function (o){
                        return o.id == indicatorID;
                    });

                    tmpCategories = [];
                    var taxSeries = {
                        name: indicatorParamsObj.label,
                        color: indicatorParamsObj.color,
                        data: []
                    };

                    _.each(indicatorObj.years, function (yObj, yearID){
                        if(yObj.value != "nodata"){
                            nbValues += 1;
                            taxSeries.data.push(yObj.value);
                            tmpCategories.push(yearID);
                        }
                    })

                    tmpTaxSeries.push(taxSeries);
                })

                if(nbValues > 0){
                    this.effectiveTaxSeries = JSON.parse(JSON.stringify(tmpTaxSeries));
                    this.effectiveTaxCategories = tmpCategories;
                    this.effectiveTaxHasData = true;
                } else {
                    this.effectiveTaxHasData = false;
                }
                
            },

            updateOffshoreFinancialChart: function (){
                var self = this;
                var dataType = "none";
                var totalUnit = "total";

                if(this.countryObj.Tax_haven_offshore_financial_wealth == "yes"){
                    dataType = "world";
                    totalUnit = "total_attracted"
                } else {
                    dataType = "regions";
                }

                this.offshoreFinancialAreaUnit = this.selectedOffshoreFinancialIndicator.smallUnit;

                var tmpSeries = [];
                var tmpCategories = [];

                
                var denominatorCountryData = _.filter(this.DBCountriesDenominator, function (o){
                    return o.iso3 == self.countryID;
                })
                
                //var denominatorCountryData = UTILS.DB_COUNTRIES_DENOMINATOR_OBJ[self.countryID];

                var yearlyDenominatorCountryObj = {};
                _.each(denominatorCountryData, function (o){
                    yearlyDenominatorCountryObj[o.year] = o;
                })

                if(dataType == "regions"){
                    _.each(UTILS.FINANCIAL_REGIONS, function (regionObj, regionID){
                        var availableYears = [];
                        var dataYears = _.map(self.offshoreFinancialCountryData.indicators[regionObj.id].years, function (yObj, yearID){ 
                            if(self.selectedOffshoreFinancialIndicator.id == "pctGDPFinancial"){
                                if(yearlyDenominatorCountryObj[yearID].gdp_USD_billion != null){
                                    availableYears.push(yearID);
                                    return (yObj.value / (yearlyDenominatorCountryObj[yearID].gdp_USD_billion)) * 100;
                                }
                                return null
                            } else if(self.selectedOffshoreFinancialIndicator.id == "pctHouseholdWealth"){
                                if(yearlyDenominatorCountryObj[yearID].personal_wealth_USD_billion != null){
                                    availableYears.push(yearID);
                                    return (yObj.value / (yearlyDenominatorCountryObj[yearID].personal_wealth_USD_billion)) * 100;
                                }
                                return null;
                            }
                            availableYears.push(yearID);
                            return yObj.value; 
                        });
                        dataYears = _.without(dataYears, null);

                        tmpSeries.push({
                            name: regionObj.label,
                            color: regionObj.color,
                            data: dataYears
                        })
                        tmpCategories = availableYears;
                    })
                } else if(dataType == "world"){
                    var availableYears = [];
                    var dataYears = _.map(self.offshoreFinancialCountryData.indicators[totalUnit].years, function (yObj, yearID){
                        if(self.selectedOffshoreFinancialIndicator.id == "pctGDPFinancial"){
                            if(yearlyDenominatorCountryObj[yearID].gdp_USD_billion != null){
                                availableYears.push(yearID);
                                return (yObj.value / (yearlyDenominatorCountryObj[yearID].gdp_USD_billion)) * 100;
                            }
                            return null
                        }
                        else if(self.selectedOffshoreFinancialIndicator.id == "pctHouseholdWealth"){
                            if(yearlyDenominatorCountryObj[yearID].personal_wealth_USD_billion != null){
                                availableYears.push(yearID);
                                return (yObj.value / (yearlyDenominatorCountryObj[yearID].personal_wealth_USD_billion)) * 100;
                            }
                            return null
                        }
                        availableYears.push(yearID);
                        return yObj.value; 
                    })
                    dataYears = _.without(dataYears, null);

                    tmpSeries.push({
                        name: "World",
                        color: "#F18321",
                        data: dataYears
                    })
                    tmpCategories = availableYears;
                }

                var uniqData = _.uniq(_.map(tmpSeries[0].data, function (val){ return val; }));

                if(tmpCategories.length == 0){
                    this.offshoreFinancialHasData = false;
                } else {
                    if(uniqData.length <= 1){
                        if(uniqData[0] == "nodata") this.offshoreFinancialHasData = false;
                    } else {
                        this.offshoreFinancialHasData = true;
                    }
                }

                this.offshoreFinancialAreaSeries = JSON.parse(JSON.stringify(tmpSeries));
                this.offshoreFinancialAreaCategories = JSON.parse(JSON.stringify(tmpCategories));
            },

            updateOffshoreFinancialHybridChart: function (){
                var self = this;
                var dataType = "none";
                var totalUnit = "total";

                dataType = "world";
                totalUnit = "total_attracted"

                this.offshoreFinancialHybridAreaUnit = this.selectedOffshoreFinancialHybridIndicator.smallUnit;

                var tmpSeries = [];
                var tmpCategories = [];

                
                var denominatorCountryData = _.filter(this.DBCountriesDenominator, function (o){
                    return o.iso3 == self.countryID;
                })
                
                //var denominatorCountryData = UTILS.DB_COUNTRIES_DENOMINATOR_OBJ[self.countryID];

                var yearlyDenominatorCountryObj = {};
                _.each(denominatorCountryData, function (o){
                    yearlyDenominatorCountryObj[o.year] = o;
                })

                if(dataType == "world"){
                    var availableYears = [];
                    var dataYears = _.map(self.offshoreFinancialHybridCountryData.indicators[totalUnit].years, function (yObj, yearID){
                        if(self.selectedOffshoreFinancialHybridIndicator.id == "pctGDPFinancial"){
                            if(yearlyDenominatorCountryObj[yearID].gdp_USD_billion != null){
                                availableYears.push(yearID);
                                return (yObj.value / (yearlyDenominatorCountryObj[yearID].gdp_USD_billion)) * 100;
                            }
                            return null
                        }
                        else if(self.selectedOffshoreFinancialHybridIndicator.id == "pctHouseholdWealth"){
                            if(yearlyDenominatorCountryObj[yearID].personal_wealth_USD_billion != null){
                                availableYears.push(yearID);
                                return (yObj.value / (yearlyDenominatorCountryObj[yearID].personal_wealth_USD_billion)) * 100;
                            }
                            return null
                        }
                        availableYears.push(yearID);
                        return yObj.value; 
                    })
                    dataYears = _.without(dataYears, null);

                    tmpSeries.push({
                        name: "World",
                        color: "#F18321",
                        data: dataYears
                    })
                    tmpCategories = availableYears;
                }

                var uniqData = _.uniq(_.map(tmpSeries[0].data, function (val){ return val; }));

                if(tmpCategories.length == 0){
                    this.offshoreFinancialHybridHasData = false;
                } else {
                    if(uniqData.length <= 1){
                        if(uniqData[0] == "nodata") this.offshoreFinancialHybridHasData = false;
                    } else {
                        this.offshoreFinancialHybridHasData = true;
                    }
                }

                this.offshoreFinancialHybridAreaSeries = JSON.parse(JSON.stringify(tmpSeries));
                this.offshoreFinancialHybridAreaCategories = JSON.parse(JSON.stringify(tmpCategories));

            },

            updateOffshoreEstateKeyFigures: function (){
                var self = this;

                var yearsObj = this.offshoreEstateCountryData.indicators["Aggregate (in USD billions)"].years;
                var years = _.keys(yearsObj);

                var lastYear = years[years.length-1];
                var lastYearObj = yearsObj[lastYear];

                /*
                var denominatorObj = _.find(this.DBCountriesDenominator, function (o){
                    return o.iso3 == self.countryID && String(o.year) == String(lastYear);
                })
                */
                var denominatorObj = UTILS.DB_COUNTRIES_DENOMINATOR_OBJ[self.countryID].years[lastYear];

                var tmpTotal = 0;
                _.each(lastYearObj, function (o){
                    if(o.value != '' && o.value != 'nodata') tmpTotal += o.value;
                })

                if(tmpTotal == 0){
                    this.offshoreEstateHasData = false;
                } else{
                    this.offshoreEstateHasData = true;
                }
                this.offshoreEstateTotal = tmpTotal;

                var tmpOffshoreEstatePctGDP = (this.offshoreEstateTotal / denominatorObj.gdp_USD_billion) * 100;
                this.offshoreEstatePctGDP = UTILS.formatFloatToSignificantDigits(tmpOffshoreEstatePctGDP, 2);

                var tmpOffshoreEstatePctWorld = (this.offshoreEstateTotal / UTILS.GLOBAL_REAL_ESTATE) * 100;
                this.offshoreEstatePctWorld = UTILS.formatFloatToSignificantDigits(tmpOffshoreEstatePctWorld, 2);

            },

            updateOffshoreEstateChart: function (){
                var self = this;
                var yearsObj = this.offshoreEstateCountryData.indicators["Aggregate (in USD billions)"].years;
                var years = _.keys(yearsObj);

                var lastYear = years[years.length-1];
                var lastYearObj = yearsObj[lastYear];

                /*
                var denominatorObj = _.find(this.DBCountriesDenominator, function (o){
                    return o.iso3 == self.countryID && String(o.year) == String(lastYear);
                })
                */
                var denominatorObj = UTILS.DB_COUNTRIES_DENOMINATOR_OBJ[self.countryID].years[lastYear];

                var tmpSeries = [];
                var tmpCategories = [];

                _.each(lastYearObj, function (yearlyObj, cityLabel){
                    if(cityLabel != "Total"){
                        var yearValue = yearlyObj.value;
                        if(self.selectedOffshoreEstateIndicator.id == "pctGDP") yearValue = (yearValue / denominatorObj.gdp_USD_billion) * 100;
                        else if(self.selectedOffshoreEstateIndicator.id == "pctGlobalEstate"){
                            var cityTotalValue = self.DBRealEstateCities[cityLabel].total;
                            yearValue = (yearValue / cityTotalValue) * 100;
                        }

                        var cityDisplayLabel = cityLabel;
                        if(cityDisplayLabel == "CoteAzur") cityDisplayLabel = "Côte d’Azur";
                        if(yearValue > 0){
                            tmpSeries.push({
                                city: cityDisplayLabel,
                                value: yearValue
                            })
                        }
                    }
                });

                var sortedSeries = _.sortBy(tmpSeries, function (o){
                    return -o.value;
                });

                tmpSeries = _.map(sortedSeries, function (o){
                    return o.value;
                })

                tmpCategories = _.map(sortedSeries, function (o){
                    return o.city;
                });

                this.offshoreEstateSeries = [{
                    name: "Cities",
                    color: "#DB8EA8",
                    data: tmpSeries
                }];

                this.offshoreEstateCategories = JSON.parse(JSON.stringify(tmpCategories));
                this.offshoreEstateIndicatorUnit = this.selectedOffshoreEstateIndicator.smallUnit;
            },

            applyFilter: function (indicatorID){

            },

            openModal: function (modalType){
                this.$refs.appModalRef.openModal(modalType);
            },

            menuClicked: function (menuType){
                this.openModal(menuType)
            },

            truncateSelectboxItem(text) {
                if(text.length > this.selectboxItemLimit) return `${text.substring(0, this.selectboxItemLimit)}...`;
                return text;
            },

            truncate(text) {
                if(text.length > this.datasetTextLimit) return `${text.substring(0, this.datasetTextLimit)}...`;
                return text;
            },

            //export Barchart callback function
            exportGraphic: function (exportType) {
                var exportParams = {
                    title: "Country: " + this.countryObj.country_name
                };
                UTILS.exportGTAB('Wrapper_' + exportType, exportParams);
            },

            //export XLS callback function
            exportXLS: function (exportType) {
                var self = this;

                var indicatorLabel = "";


                var tableArray = [];
                var exportDataArray = [];
                var exportDataArray2 = [];
                var exportDataYears = "";

                if(exportType == "profit"){

                    if(this.selectedGlobalProfitIndicator.id != 'corp_tax_lost'){
                        indicatorLabel += this.selectedGlobalProfitIndicator.label;
                        if(!this.isTaxHavenGlobalProfit) indicatorLabel += " lost";
                        else indicatorLabel += " won";
                    } else {
                        indicatorLabel = "Corporate tax revenue";
                        if(!this.isTaxHavenGlobalProfit) indicatorLabel += " lost";
                        else indicatorLabel += " won";
                        indicatorLabel += " as a share of corporate tax revenue collected";
                    }

                    exportDataYears = this.globalProfitAreaCategories;
                    exportDataArray = this.globalProfitAreaSeries[0].data;
                    if(this.globalProfitAreaSeries.length > 1){
                        tableArray = [["Year", "Non-Eu Havens (in " + this.globalProfitIndicatorUnit + ")", "Eu Havens (in " + this.globalProfitIndicatorUnit + ")"]];
                        exportDataArray2 = this.globalProfitAreaSeries[1].data;
                    } else {
                        tableArray = [["Year", "Value (in " + this.globalProfitIndicatorUnit + ")"]]
                    }
                    
                } else if(exportType == "effective"){
                    var indicatorsLabels = _.map(this.effectiveTaxSeries, function (o){
                        return o.name;
                    })
                    indicatorsLabels.unshift("Year");
                    tableArray = [indicatorsLabels];

                    _.each(this.effectiveTaxCategories, function (yearStr, incYear){
                        var incArray = _.map(self.effectiveTaxSeries, function (o){
                            return UTILS.formatNumber(o.data[incYear],2, "%");
                        })
                        incArray.unshift(yearStr);
                        tableArray.push(incArray);
                    })
                } else if(exportType == "estate"){
                    if(this.selectedOffshoreEstateIndicator.id == 'pctGDP') indicatorLabel = "Offshore real estate owned as a share of country’s GDP";
                    else if(this.selectedOffshoreEstateIndicator.id == 'Aggregate (in USD billions)') indicatorLabel = "Total offshore real estate owned"
                    else if(this.selectedOffshoreEstateIndicator.id == 'pctGlobalEstate') indicatorLabel = "Share of total offshore real estate in city: Offshore real estate owned as a share of the total offshore real estate in the city or area";
                    indicatorLabel += " (in " + this.offshoreEstateIndicatorUnit + ")";

                    tableArray = [["City", indicatorLabel]];
                    exportDataArray = this.offshoreEstateSeries[0].data;
                    exportDataYears = this.offshoreEstateCategories; 
                } else if(exportType == "financial"){

                    indicatorLabel = this.selectedOffshoreFinancialIndicator.subtitleLabel;
                    if(!this.isTaxHavenOffshoreFinancial) indicatorLabel += " owned";
                    else indicatorLabel += " held";

                    if(this.selectedOffshoreFinancialIndicator.homeUnit != undefined) indicatorLabel += " (in " + this.selectedOffshoreFinancialIndicator.homeUnit + ")"
                    else indicatorLabel += " (in "+ this.selectedOffshoreFinancialIndicator.unit +")"

                    var indicatorsLabels = _.map(this.offshoreFinancialAreaSeries, function (o){
                        return o.name;
                    })
                    indicatorsLabels.unshift("Year");
                    tableArray = [indicatorsLabels];

                    _.each(this.offshoreFinancialAreaCategories, function (yearStr, incYear){
                        var incArray = _.map(self.offshoreFinancialAreaSeries, function (o){
                            return UTILS.formatNumber(o.data[incYear],2,self.selectedOffshoreFinancialIndicator.unit);
                        })
                        incArray.unshift(yearStr);
                        tableArray.push(incArray);
                    })
                } else if(exportType == "financial-hybrid"){
                    indicatorLabel = this.selectedOffshoreFinancialHybridIndicator.subtitleLabel;
                    indicatorLabel += " owned";

                    if(this.selectedOffshoreFinancialHybridIndicator.homeUnit != undefined) indicatorLabel += " (in " + this.selectedOffshoreFinancialHybridIndicator.homeUnit + ")"
                    else indicatorLabel += " (in "+ this.selectedOffshoreFinancialHybridIndicator.unit +")"

                    var indicatorsLabels = _.map(this.offshoreFinancialHybridAreaSeries, function (o){
                        return o.name;
                    })
                    indicatorsLabels.unshift("Year");
                    tableArray = [indicatorsLabels];

                    _.each(this.offshoreFinancialHybridAreaCategories, function (yearStr, incYear){
                        var incArray = _.map(self.offshoreFinancialHybridAreaSeries, function (o){
                            return UTILS.formatNumber(o.data[incYear],2,self.selectedOffshoreFinancialHybridIndicator.unit);
                        })
                        incArray.unshift(yearStr);
                        tableArray.push(incArray);
                    })
                }

                if(exportType != "effective" && exportType != "financial" && exportType != "financial-hybrid"){
                    _.each(exportDataArray, function (objData, index){
                        var objValue = "";
                        var objFirstCol = "";
                        objValue = UTILS.formatNumber(objData, 2, self.selectedGlobalProfitIndicator.unit);
                        objFirstCol = exportDataYears[index];

                        if(exportType == "profit" && self.globalProfitAreaSeries.length > 1){
                            tableArray.push([objFirstCol, objValue, UTILS.formatNumber(exportDataArray2[index],2, self.selectedGlobalProfitIndicator.unit)]);
                        } else{
                            tableArray.push([objFirstCol, objValue]);
                        }
                    })
                }
                

                tableArray.push(['','','','','']);
                tableArray.push(['','','','','']);

                if(exportType == "profit"){
                    tableArray.push(['Indicator', indicatorLabel,'','','']);
                } else if(exportType == "estate"){
                    tableArray.push(['Indicator', indicatorLabel,'','','']);
                } else if(exportType == "financial" || exportType == "financial-hybrid"){
                    tableArray.push(['Indicator', indicatorLabel,'','','']);
                } else if(exportType == "effective"){
                    tableArray.push(['Indicator', this.DBDatasetsTexts['effective-tax'].title,'','','']);
                }

                tableArray.push(['','','','','']);
                tableArray.push(['','','','','']);
                tableArray.push(['Eu Tax Observatory Global Repository','','','','']);
                tableArray.push([location.href,'','','','']);
                tableArray.push(['Exported on',UTILS.getCurrentDate(),'','','']);

                generateXLS(tableArray);
            }

        },

        watch: {
            selectedGlobalProfitIndicator: function (){
                if(this.isDataLoaded){
                    this.updateGlobalProfitChart();
                }
            },

            selectedOffshoreEstateIndicator: function (){
                if(this.isDataLoaded){
                    this.updateOffshoreEstateChart();
                }
            },

            selectedOffshoreFinancialIndicator: function () {
                if(this.isDataLoaded){
                    this.updateOffshoreFinancialChart();
                }
            },

            selectedOffshoreFinancialHybridIndicator: function () {
                if(this.isDataLoaded){
                    this.updateOffshoreFinancialHybridChart();
                }
            }
        }
    }

</script>

<style lang="scss">
    @import "~assets/scss/_variables.scss";
    @import "~assets/scss/_browsers.scss";

    #Country{
        .main{
            background: #fff;
            .main_section{
                &.section_chart{
                    background: linear-gradient(180deg, #EEF1F6 0%, rgba(238, 241, 246, 0.00) 100%) !important;
                    .section_hr{
                        margin-top: 10px;
                    }
                    .row_filters{
                        margin-top: 10px;
                        padding-bottom: 20px;
                        border-bottom: 1px solid #bac6df;
                    }
                    .section_content{
                        position: relative;
                    }
                    .title_taxhaven{
                        background: $colorOrange;
                        position: absolute;
                        left: 0px;
                        top: -14px;
                        padding: 0px 12px;
                        font-size: 16px;
                        color: $colorBlack;
                        font-weight: 700;
                        height: 24px;
                        line-height: 24px;
                        text-align: center;
                        border-radius: 12px;
                    }
                    .content_title{
                        font-weight: 400;
                    }
                    .section_row{
                        .area_title{
                            height: 20px;
                            line-height: 20px;
                            font-size: 16px;
                            text-align: left;
                            .title_label{
                                display: inline-block;
                                vertical-align: middle;
                            }
                            .title_lostwon{
                                display: inline-block;
                                vertical-align: middle;
                                height: 24px;
                                margin: 0 5px;
                                line-height: 24px;
                                padding: 0 12px;
                                color: #fff;
                                font-weight: 700;
                                border-radius: 20px;
                                background: $colorBlue;
                                &[data-taxhavens="true"]{
                                    background: $colorOrange;
                                }
                            }
                        }
                        .row_estate_item{
                            background: #FED5AF;
                            height: 120px;
                            width: 296px;
                            padding: 20px 40px;
                            margin-right: 10px;
                            display: inline-block;
                            vertical-align: top;
                            text-align: left;
                            position: relative;
                            .estate_item_wrapper{
                                position: absolute;
                                left: 40px;
                                right: 40px;
                                top: 50%;
                                transform: translate(0, -50%);
                            }
                            .estate_item_label{
                                font-size: 16px;
                                line-height: 20px;
                                color: $colorBlack;
                            }
                            .estate_item_value{
                                color: $colorBlue;
                                font-size: 24px;
                                font-weight: 900;
                            }
                        }
                        .row_estate_barchart{
                            height: 200px;
                            width: 100%;
                            position: relative;
                        }
                    }
                }

                &[data-dataset="global-profit"]{
                    position: relative;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// pages/country/_countryID.vue